import { z } from 'zod';
/**
 * Stable, machine-readable error codes. The frontend maps a code to a
 * translated message; it never parses the human-readable `message`.
 * Add codes, never repurpose them.
 */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'USERNAME_TAKEN',
    'NO_PLATFORM_ACCESS',
    'UA_UNAVAILABLE',
    'UNAUTHENTICATED',
    'INVALID_CREDENTIALS',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'UNIQUE_VIOLATION',
    'FOREIGN_KEY_VIOLATION',
    'RATE_LIMITED',
    'IDEMPOTENCY_KEY_REUSED',
    'REQUEST_IN_PROGRESS',
    'PAYLOAD_TOO_LARGE',
    'UNPROCESSABLE',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    // Transfers domain (transfers.md). Clients translate the code; `error.data`
    // carries safe detail such as the holder and balance for INSUFFICIENT_BALANCE.
    'NO_TIER_FOR_AMOUNT',
    'COMMISSION_NOT_BELOW_AMOUNT',
    'INSUFFICIENT_BALANCE',
    'TIER_LIMIT_TAKEN',
    'TIER_UNLIMITED_EXISTS',
    'IN_USE',
    'HOLDER_INACTIVE',
    'BRANCH_NOT_ALLOWED',
    'CODE_TAKEN',
    'IBAN_TAKEN',
    'ACCOUNT_NUMBER_TAKEN',
    'INVALID_STATE',
    'CAPTURE_INCOMPLETE',
    'NOTHING_TO_CHANGE',
    // The shared tablet service (tablet.md section 2): not configured on this
    // server, unreachable, the tablet is not an active tablet of the branch, or
    // it shows another task (error.data.system names the system using it).
    'TABLET_NOT_CONFIGURED',
    'TABLET_UNAVAILABLE',
    'TABLET_NOT_AVAILABLE',
    'TABLET_BUSY',
    'FILE_INVALID',
    'CUSTOMERS_UNAVAILABLE',
    // العميل غير موجود (TRF-70): a form cannot be sent for, and party data cannot
    // be entered on, a transfer saved without the customer.
    'CUSTOMER_NOT_PRESENT',
    // The shared phone rule (customers.md section 9.3).
    'PHONE_REQUIRED',
    'PHONE_INVALID',
    'PHONE_NOT_MOBILE',
    'PHONE_COUNTRY_NOT_ALLOWED',
    // WhatsApp phone verification (customers.md section 10, transfers.md
    // section 10): the codes of the Customers verification service, passed
    // through so the dialog shows the right state.
    'PHONE_VERIFICATION_REQUIRED',
    'PHONE_VERIFICATION_INVALID',
    'PHONE_VERIFICATION_RECEIPT_EXPIRED',
    'OTP_INVALID',
    'OTP_EXPIRED',
    'OTP_ATTEMPTS_EXCEEDED',
    'OTP_RESEND_TOO_SOON',
    'OTP_SEND_LIMIT',
    'OTP_SEND_FAILED',
    'OTP_ALREADY_VERIFIED',
    'OTP_ALREADY_CONSUMED',
    'OTP_BINDING_MISMATCH',
    'OTP_NOT_VERIFIED',
    'OTP_CONSUME_WINDOW_PASSED',
    'IDEMPOTENCY_CONFLICT',
    // A save refused while the outbox sends the same transfer's Customers call (customers.md 9.7).
    'CUSTOMERS_CALL_IN_FLIGHT',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const fieldErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
    code: z.string().optional(),
});
//# sourceMappingURL=api-error.js.map